import { DateTime } from 'luxon'

const getNowHour = () => Math.ceil(DateTime.local().endOf('hour').toSeconds())
const getNowDay = () => Math.ceil(DateTime.local().endOf('day').toSeconds())

export const ticks_24_hours = () => {
  const nowHour = getNowHour()
  return [
    nowHour - (60 * 60 * 24), 
    nowHour - (60 * 60 * 22), nowHour - (60 * 60 * 20),
    nowHour - (60 * 60 * 18), nowHour - (60 * 60 * 16),
    nowHour - (60 * 60 * 14), nowHour - (60 * 60 * 12),
    nowHour - (60 * 60 * 10), nowHour - (60 * 60 *  8),
    nowHour - (60 * 60 *  6), nowHour - (60 * 60 *  4),
    nowHour - (60 * 60 *  2), nowHour
  ]
}

export const ticks_custom = (startDateTime, endDateTime) => {
  const diffTime = Math.abs(endDateTime - startDateTime)
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  let arrayOfTicks = []
  const endTime = Math.ceil(endDateTime.startOf('day').toSeconds())
  const startTime = Math.ceil(startDateTime.startOf('day').toSeconds())
  if(diffDays <= 1)
  {
    arrayOfTicks = [
      startTime + (60 * 60 * 24), 
      startTime + (60 * 60 * 22), startTime + (60 * 60 * 20),
      startTime + (60 * 60 * 18), startTime + (60 * 60 * 16),
      startTime + (60 * 60 * 14), startTime + (60 * 60 * 12),
      startTime + (60 * 60 * 10), startTime + (60 * 60 *  8),
      startTime + (60 * 60 *  6), startTime + (60 * 60 *  4),
      startTime + (60 * 60 *  2), endTime
    ]
  }
  else if(diffDays <= 7)
  {
    arrayOfTicks = [
      endTime - (60 * 60 * 24 * 7), 
      endTime - (60 * 60 * 24 * 6), 
      endTime - (60 * 60 * 24 * 5), 
      endTime - (60 * 60 * 24 * 4),
      endTime - (60 * 60 * 24 * 3),
      endTime - (60 * 60 * 24 * 2),
      endTime - (60 * 60 * 24 * 1),
      endTime
    ]
  }
  else if(diffDays <= 30)
  {
    arrayOfTicks = [
      endTime - (60 * 60 * 24 * 30), 
      endTime - (60 * 60 * 24 * 25), 
      endTime - (60 * 60 * 24 * 20), 
      endTime - (60 * 60 * 24 * 15),
      endTime - (60 * 60 * 24 * 10),
      endTime - (60 * 60 * 24 * 5),
      endTime
    ]
  }
  return arrayOfTicks
}

export const ticks_7_days = () => {
  const nowDay = getNowDay()
  return [
    nowDay - (60 * 60 * 24 * 7), 
    nowDay - (60 * 60 * 24 * 6), 
    nowDay - (60 * 60 * 24 * 5), 
    nowDay - (60 * 60 * 24 * 4),
    nowDay - (60 * 60 * 24 * 3),
    nowDay - (60 * 60 * 24 * 2),
    nowDay - (60 * 60 * 24 * 1),
    nowDay
  ]
}

export const ticks_30_days = () => {
  const nowDay = getNowDay()
  const tics = [nowDay]
  for (let day = 0; day < 29; day++) { 
    tics.unshift(nowDay - (60 * 60 * 24 * day))
  }
}